import { getToken } from '@/service/auth'

export const SSO_MESSAGE_TYPE = 'CHUAIDOU_SSO'
export const SSO_REQUEST_TYPE = 'CHUAIDOU_SSO_REQUEST'
export const SSO_ACK_TYPE = 'CHUAIDOU_SSO_ACK'

const DEFAULT_DISTRIBUTION_LOGIN_URL = 'https://cd-trip.com.cn/login'

/** 是否以分销 iframe 内嵌方式运行（顶层窗口单独打开不算嵌入） */
export function isEmbedMode() {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}

/** 分销系统登录页地址，可通过 VUE_APP_DISTRIBUTION_LOGIN_URL 配置 */
export function getDistributionLoginUrl() {
  const configured = process.env.VUE_APP_DISTRIBUTION_LOGIN_URL
  if (configured) {
    return configured
  }
  return DEFAULT_DISTRIBUTION_LOGIN_URL
}

/** 非嵌入访问时跳转分销登录页 */
export function redirectToDistributionLogin() {
  window.location.replace(getDistributionLoginUrl())
}

export function readTokenFromUrl() {
  const params = new URLSearchParams(window.location.search)
  return params.get('distributionToken') || params.get('token') || ''
}

function requestTokenFromParent() {
  try {
    window.parent.postMessage({ type: SSO_REQUEST_TYPE }, '*')
  } catch (e) {
    // ignore cross-origin edge cases
  }
}

/** 等待父页面（分销前端）通过 URL 或 postMessage 下发 Token */
export function waitForDistributionToken(timeout = 8000) {
  const urlToken = readTokenFromUrl()
  if (urlToken) {
    return Promise.resolve(urlToken)
  }

  return new Promise((resolve) => {
    let retryTimer = null

    const handler = (event) => {
      if (event.data?.type !== SSO_MESSAGE_TYPE || !event.data?.token) {
        return
      }
      if (event.source && event.source !== window.parent) {
        return
      }
      cleanup()
      resolve(event.data.token)
    }

    const deadline = setTimeout(() => {
      cleanup()
      resolve(null)
    }, timeout)

    function cleanup() {
      clearTimeout(deadline)
      if (retryTimer) {
        clearInterval(retryTimer)
      }
      window.removeEventListener('message', handler)
    }

    window.addEventListener('message', handler)
    requestTokenFromParent()
    retryTimer = setInterval(requestTokenFromParent, 300)
  })
}

/** 监听父页面延迟下发的 Token（仅登录竞态窗口内使用，成功后应注销） */
export function listenDistributionToken(callback) {
  if (getToken()) {
    return () => {}
  }
  const handler = (event) => {
    if (event.data?.type !== SSO_MESSAGE_TYPE || !event.data?.token) {
      return
    }
    if (event.source && event.source !== window.parent) {
      return
    }
    callback(event.data.token, event.data)
  }
  window.addEventListener('message', handler)
  requestTokenFromParent()
  return () => window.removeEventListener('message', handler)
}

/** 通知分销父页面：子应用 SSO 已完成，停止 Token 轮询 */
export function notifyDistributionReady() {
  try {
    window.parent.postMessage({ type: SSO_ACK_TYPE }, '*')
  } catch (e) {
    // ignore cross-origin edge cases
  }
}

export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}
